// @flow
export default {
  container: {
    marginTop: 16
  }
}
